
import { Component, Prop, Vue, Emit, Model } from 'vue-property-decorator'
import { EnumProductTypeQuery } from '@xt/client/enums/product'

@Component
export default class extends Vue {
  @Prop({ default: false }) username //appid
  @Prop({ default: false }) path //页面路径
  @Prop({ default: 'position: absolute;width: 100%;height: 100%;' }) launchStyle //标签上样式
  @Prop({ default: '' }) outerStyle //最外层上样式
  @Prop({ default: '' }) query //参数
  @Prop({ default: 'release' }) envVersion //环境变量版本
  @Prop({ default: null }) extraData //扩展数据
  @Prop({ default: EnumProductTypeQuery.Exhibition }) type
  innerHtml = ''
  get WechatBowser() {
    return this.$store.$global.WechatBowser
  }
  get isEmbeddedH5Page() {
    return this.$store.$global.isEmbeddedH5Page
  }
  get orderPage() {
    // @ts-expect-error
    return ['my-order'].includes(this.$route.name?.replace(/-(index)/g, ''))
  }
  goWeApp() {
    if (!this.WechatBowser) {
      return this.$msg('请在微信内操作')
    }
  }
  @Emit('launch')
  goThirdMiniProgram() {
    wx.miniProgram.navigateTo({
      url: `/pages/fallback/index?url=${encodeURIComponent(this.path)}&type=${this.type}`
    })
  }
  created() {}
  handleErrorFn() {
    console.log('handleErrorFn error')
  }
  handleLaunchFn(data) {
    console.log('handleLaunchFn success', data)
    this.$emit('launch')
  }
  mounted() {}
}
